import {
  HeaderMenu,
  Card,
  DateInput,
  Loading, 
  Button,
  FooterMenu
} from "components"
import moment from "moment"
import React, { useEffect, useState } from "react"
import { convertNumber } from "utils"
import { useList } from "./utils/useList"
import toast from "react-hot-toast"
import { exportExcelAnalyseSalesPeriode } from "./utils/exportExcelAnalyseSalesPeriode"
import { ExportPDFAnalyseSalesPeriode, PrintPDFAnalyseSalesPeriode } from "./utils/exportPDFAnalyseSalesPeriode"
// import { ReactBarcode } from "react-jsbarcode"

export default function ListAnalyse(){
    const [fill, setFill] = useState<{ start_date: string, end_date: string}>({
		start_date:  moment().startOf("month").format("YYYY-MM-DD"),
		end_date: moment().endOf("month").format("YYYY-MM-DD"),
	})

	const { data, fetchData, loading } = useList()

        const isRangeMoreThanOneMonth = (start: string, end: string) => {
        return moment(end).diff(moment(start), "months", true) > 1
        }

    function handleSubmitFillter(){
        if (isRangeMoreThanOneMonth(fill.start_date, fill.end_date)) {
            toast.error("Maximum date range 1 month");
            return;
        }

        fetchData(fill);

    }

    useEffect(() => {
        fetchData(fill)
        // eslint-disable-next-line
    }, [])

    let rowNumber = 1;
    
    return(
        <section>
            <section className="mt-1 mx-3">
                <HeaderMenu title="INVOICE LIST" />
            </section>

            <section className="mx-3">
            <Card>
            <Card.Body>
                <section className="lg:flex overflow-x-auto">
                <div className="flex w-full"> 
                    <div className="flex items-center w-[284px] lg:w-[250px] mx-2">
                        <div className="label-text pb-1 font-bold pe-2 lg:w-[145px] w-[350px] uppercase">
                            START DATE
                        </div>
                        <DateInput
                            className="!w-[150px]"
                            selected={moment(fill.start_date).toDate()}
                            onChange={(date) => {
                                const startDate = moment(date)
                                const maxEndDate = startDate.clone().add(1, "month")

                                setFill({
                                start_date: startDate.format("YYYY-MM-DD"),
                                end_date: moment(fill.end_date).isAfter(maxEndDate)
                                    ? maxEndDate.format("YYYY-MM-DD")
                                    : fill.end_date
                                })
                            }}
                        />
                    </div>
                    <div className="flex items-center w-[284px] lg:w-[250px] mt-2 lg:mt-0 mx-2">
                        <div className="lg:mt-0 lg:px-2 pb-1 label-text font-bold lg:w-[110px] !w-[550px] uppercase">
                            END DATE
                        </div>
                        <DateInput
                            className="!w-[150px]"
                            selected={moment(fill.end_date).toDate()}
                            minDate={moment(fill.start_date).toDate()}
                            maxDate={moment(fill.start_date).add(1, "month").toDate()}
                            onChange={(date) =>
                            setFill({
                                ...fill,
                                end_date: moment(date).format("YYYY-MM-DD")
                            })
                            }
                        />
                    </div>
                    <div className="flex items-center ml-1 mt-2 lg:mt-0 mx-2">
                   
                        <Button
                            type="submit"
                            color="primary"
                            onClick={handleSubmitFillter}
                        >
                            Submit
                        </Button>
                
                    </div>
                </div>
            
                </section>
            </Card.Body>
            </Card>
            </section>

            <section className="mx-3">
                <Card className="mb-2">
                <Card.Body>
                    <div className="overflow-x-auto max-h-[calc(100vh-400px)]">
                    <table className="table table-bordered">
                        <thead className="top-0 z-1 !bg-black !text-white">
                            <tr>
                                <th>NO</th>
                                <th className="min-w-[150px]">DATE</th>
                                <th>INVOICE ID</th>
                                <th>CUSTOMER</th>
                                <th>LOCATION</th>
                                <th>ITEM CODE</th>
                                <th>DESCRIPTION</th>
                                <th>QTY</th>
                                <th>UNIT</th>
                                <th>PRICE</th>
                                <th>EXT. AMOUNT</th>
                                <th>TAX</th>
                                <th>JOB</th>

                                <th className="w-8 border-0 bg-white"></th>
                                <th>COGM</th>
                                <th>COGM AMOUNT</th>
                                <th>SALES PROFIT</th>
                            </tr>
                        </thead>
                        <tbody>
                        {loading || data?.length === 0 ? (
                            <tr>
                            <td colSpan={12}>
                                <Loading
                                loading={loading}
                                errorText="No data available"
                                />
                            </td>
                            </tr>
                        ) : (
                            data?.map((group, dateIndex) => (
                                <React.Fragment key={dateIndex}>
                                  {/* Baris tanggal */}
                                  <tr className="!bg-gray-300 font-bold">
                                    <td colSpan={13}>{moment(group.transaction_date).format('DD/MM/YYYY')}</td>
                                    <td className="bg-white"></td>
                                    <td colSpan={3}></td>
                                  </tr>
                              
                                  {/* Loop invoice di bawah tanggal */}
                                  {group.invoices.map((invoice, invIndex) => (
                                    <React.Fragment key={`${dateIndex}-${invIndex}`}>
                                        <tr className="!bg-gray-100">
                                            <td className="font-bold" colSpan={13}>{invoice.trx_code}</td>
                                            <td className="bg-white"></td>
                                            <td colSpan={3}></td>
                                        </tr>
                                        {invoice.items.map((item, itemIndex) => (
                                            <tr key={`${dateIndex}-${invIndex}-${itemIndex}`}>
                                                <td className="text-center">{rowNumber++}</td>
                                                <td>{moment(item.transaction_date).format('DD/MM/YYYY')}</td>
                                                <td>{item.trx_code}</td>
                                                <td>{item.customer_name}</td>
                                                <td>{item.location_name}</td>
                                                <td>{item.product_barcode}</td>
                                                {/* <td>
                                                    <ReactBarcode
                                                        value={item.product_barcode} 
                                                        options={{ 
                                                            displayValue: false,
                                                            width: 1,
                                                            height: 30,
                                                            margin: 0, 
                                                        }}
                                                    />
                                                </td> */}
                                                <td>{item.product_name}</td>
                                                <td className="text-center">{convertNumber(Number(item.quantity_invoice)).intoNormalAmount}</td>
                                                <td>{item.unit_sell_measure_name}</td>
                                                <td className="text-end">{convertNumber(Number(item.price_invoice)).intoCurrency}</td>
                                                <td className="text-end">{convertNumber(Number(item.total)).intoCurrency}</td>
                                                <td>{`${item.tax_name}(${convertNumber(Number(item.tax_rate)).intoNormalAmount}%)`}</td>
                                                <td>{item.project_name}</td>
                                                <td className="bg-white"></td>
                                                <td className="text-end">{convertNumber(Number(item.cogm)).intoCurrency}</td>
                                                <td className="text-end">{convertNumber(Number(item.cogm_amount)).intoCurrency}</td>
                                                <td className="text-end">{convertNumber(Number(item.sale_profit)).intoCurrency}</td>
                                            </tr>
                                        ))}
                                    </React.Fragment>
                                  ))}
                                   <tr className="!bg-gray-100 font-bold">
                                        <td className="text-end" colSpan={7}>Total : {moment(group.transaction_date).format('DD/MM/YYYY')}</td>
                                        <td className="text-center">{convertNumber(group.total_quantity).intoNormalAmount}</td>
                                        <td></td>
                                        <td></td>
                                        <td className="text-end">{convertNumber(group.total_amount).intoCurrency}</td>
                                        <td></td>
                                        <td></td>
                                        <td className="bg-white"></td>
                                        <td></td>
                                        <td className="text-end">{convertNumber(group.total_cogm_amount).intoCurrency}</td>
                                        <td className="text-end">{convertNumber(group.total_sale_profit).intoCurrency}</td>
                                    </tr>
                                </React.Fragment>
                            ))
                        )}
                        </tbody>
                    </table>
                    </div>

                </Card.Body>
                </Card>
                <FooterMenu
                    printRight
                    export={{
                        actiontype: "export",
                        onClick: () => exportExcelAnalyseSalesPeriode(data!)
                    }}
            
                    pdf={{
                        actiontype: "pdf",
                        onClick: () => ExportPDFAnalyseSalesPeriode(data!)
                    }}
                    print={{
                        actiontype: "print",
                        onClick: () => PrintPDFAnalyseSalesPeriode(data!)
                    }}
                    />
            </section>
            
        </section>
    )
}
